<script>
  import { createEventDispatcher } from 'svelte';
  import InputFeedComponent from "../../InputFeedComponent.svelte";
  import { mic_error, mic_hover, mic_listening, mic_success, mic_reset, mic_restart, mic_restartHover } from '../../SpeechTestSVG.svelte';

  export let matchInput;
  export let lastInput;
  export let currentTextInput;
  export let focusTrap;
  export let contextContent;
  export let listening;
  export let indicateRestart;
  export let microphoneExists;
  export let speechAllowed;
  let submitInput;
  let micBtn;
  export let playingSuccess = false;
  const clickToStartTextVar = "click to start speech recognition";
  let clickToStartText = clickToStartTextVar;

  const dispatch = createEventDispatcher();

  $:{
    if(indicateRestart)
    {
      clickToStartText = ""
      micRestart();
    }
    else
      micReset();
  }

  function onClickHandler(micBtnClickFn)
  {      
    if(indicateRestart)
    {        
      clickToStartText = clickToStartTextVar;
      indicateRestart = false;
      dispatch('restartSpeechTest'); 
      return;
    }
    if(!listening)
    {          
      micBtnClickFn();
      mic_listening();
    }
  }
  
  export function micRestart()
  {
    clickToStartText = ""
    mic_restart();
  }

  export function micReset()
  {
    clickToStartText = clickToStartTextVar;
    playingSuccess = false;
    mic_reset();
  }

  export function micError()
  {
    clickToStartText = ""
    playingSuccess = false;
    mic_error();
  }

  export function playMicSuccess(){
    clickToStartText = "";
    playingSuccess = true;
    mic_success();
  }

  export function enableMicClicks()
  {
    micBtn.style.pointerEvents = "all";
  }

  export function disableMicClicks()
  {
    micBtn.style.pointerEvents = "none";
  }

  function hoverHandler()
  {
    if(!indicateRestart && !listening && !playingSuccess)
      mic_hover();  
    else if(indicateRestart)
      mic_restartHover();
  }

  function hoverMouseExit()
  {
    if(!indicateRestart && !listening && !playingSuccess)
      mic_reset();
    else if(indicateRestart)
      mic_restart();
  }
</script>

<style lang="less">
.buttonCircle
{
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: none;
  color: #023b5a;
  font-weight: bold;    
  margin: 0 auto;
}

.buttonCircle
{
  display: block;
}

.buttonDiv
{
  width: 10%;
  margin: 0 auto;
  display: flex;
  align-items: center;
}

.micBtn:focus,
.btn_content:focus
{
  outline: none;
}

.btn_content
{
  display: inline-block;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  pointer-events: all;
}

.micBtn
{
    background: transparent;
    border: none !important;
    border-radius: 50%;
    width: 10%;
    height: 25%;
    margin: 0 auto;
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    padding: 0;
    cursor: pointer;
    pointer-events: none;
}

.micBtn:focus > .btn_content {
  box-shadow: inset 0 0 3px 3px #023b5a, 0 0 0px 0px #023b5a;
  cursor: pointer;
}

#speechRecognitionHelp
{
    font-size: 1vw;
    color: #023b5a;
    display: inline-block;
    margin: 0 auto;
    text-align: center;
    font-style: italic;
}
</style>

<InputFeedComponent bind:matchInput bind:lastInput bind:currentTextInput bind:focusTrap={focusTrap} bind:submitInput bind:micBtn={micBtn} bind:listening let:micBtnClick={micBtnClick}>
  <div class="buttonDiv" slot="micBtn">            
      <div class="buttonCircle" id="buttonCircle">
          {#if speechAllowed && microphoneExists}
            <button type="button" class="micBtn" id="micBtn" on:click={onClickHandler(micBtnClick)} on:mouseenter={hoverHandler} on:mouseleave={hoverMouseExit} aria-label="Microphone" tabindex="3"><span class="btn_content" bind:this={micBtn} tabindex="-1" aria-hidden="true"></span></button>
          {/if}
          <svg
          id="e3ix9ha1nk2e1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 213 213"
          shape-rendering="geometricPrecision"
          text-rendering="geometricPrecision">
          <style>
            #pulsering {
              animation: pulsering__ts 2000ms linear infinite normal forwards;
            }
            @keyframes pulsering__ts {
              0% {
                transform: translate(105.45px, 105.45px) scale(0.5, 0.5);
              }
              15% {
                transform: translate(105.45px, 105.45px) scale(0.8, 0.8);
              }
              40% {
                transform: translate(105.45px, 105.45px) scale(1, 1);
              }
              100% {
                transform: translate(105.45px, 105.45px) scale(1, 1);
              }
            }
            #pulsering_path {
              animation-name: pulsering_path_s_o, pulsering_path_s_w;
              animation-duration: 2000ms;
              animation-fill-mode: forwards;
              animation-timing-function: linear;
              animation-direction: normal;
              animation-iteration-count: infinite;
            }
            @keyframes pulsering_path_s_o {
              0% {
                stroke-opacity: 0;
              }
              15% {
                stroke-opacity: 0.3;
              }
              25% {
                stroke-opacity: 0.3;
              }
              100% {
                stroke-opacity: 0.3;
              }
            }
            @keyframes pulsering_path_s_w {
              0% {
                stroke-width: 10;
              }
              15% {
                stroke-width: 10;
                animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
              }
              40% {
                stroke-width: 0;
              }
              100% {
                stroke-width: 0;
              }
            }
            #pulsecircleB {
              animation: pulsecircleB__ts 2000ms linear infinite normal forwards;
            }
            @keyframes pulsecircleB__ts {
              0% {
                transform: translate(105.45px, 105.45px) scale(0.5, 0.5);
              }
              25% {
                transform: translate(105.45px, 105.45px) scale(0.8, 0.8);
                animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
              }
              50% {
                transform: translate(105.45px, 105.45px) scale(0.1, 0.1);
              }
              100% {
                transform: translate(105.45px, 105.45px) scale(0.1, 0.1);
              }
            }
            #pulsecircleB_path {
              animation: pulsecircleB_path_f_o 2000ms linear infinite normal forwards;
            }
            @keyframes pulsecircleB_path_f_o {
              0% {
                fill-opacity: 0.3;
              }
              25% {
                fill-opacity: 0;
              }
              100% {
                fill-opacity: 0;
              }
            }
            #pulsecircleA {
              animation: pulsecircleA__ts 2000ms linear infinite normal forwards;
            }
            @keyframes pulsecircleA__ts {
              0% {
                transform: translate(105.45px, 105.45px) scale(1, 1);
              }
              5% {
                transform: translate(105.45px, 105.45px) scale(1.25, 1.25);
              }
              50% {
                transform: translate(105.45px, 105.45px) scale(0, 0);
                animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
              }
              75% {
                transform: translate(105.45px, 105.45px) scale(0, 0);
              }
              100% {
                transform: translate(105.45px, 105.45px) scale(1, 1);
              }
            }
            #hoveroutercircle {
              animation: hoveroutercircle__ts 2000ms linear infinite normal forwards;
            }
            @keyframes hoveroutercircle__ts {
              0% {
                transform: translate(105.45px, 105.45px) scale(0, 0);
                animation-timing-function: cubic-bezier(0.705, -0.005, 0.295, 0.985);
              }
              25% {
                transform: translate(105.45px, 105.45px) scale(1, 1);
                animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
              }
              40% {
                transform: translate(105.45px, 105.45px) scale(0.95, 0.95);
              }
              100% {
                transform: translate(105.45px, 105.45px) scale(0.95, 0.95);
              }
            }
            #hoveroutercircle_path {
              animation: hoveroutercircle_path__fl 2000ms linear infinite normal forwards;
            }
            @keyframes hoveroutercircle_path__fl {
              0% {
                stroke-width: 5;
              }
              25% {
                stroke-width: 5;
              }
              40% {
                stroke-width: 8;
              }
              100% {
                stroke-width: 8;
              }
            }
            #hoverinnercircle {
              animation: hoverinnercircle__ts 2000ms linear infinite normal forwards;
            }
            @keyframes hoverinnercircle__ts {
              0% {
                transform: translate(105.45px, 105.45px) scale(0, 0);
                animation-timing-function: cubic-bezier(0.705, -0.005, 0.295, 0.985);
              }
              25% {
                transform: translate(105.45px, 105.45px) scale(0.99, 0.99);
                animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
              }
              40% {
                transform: translate(105.45px, 105.45px) scale(0.92, 0.92);
              }
              100% {
                transform: translate(105.45px, 105.45px) scale(0.92, 0.92);
              }
            }
            #hoverinnercircle_path {
              animation-name: hoverinnercircle_path__fl, hoverinnercircle_path_s_o;
              animation-duration: 2000ms;
              animation-fill-mode: forwards;
              animation-timing-function: linear;
              animation-direction: normal;
              animation-iteration-count: infinite;
            }
            @keyframes hoverinnercircle_path__fl {
              0% {
                filter: blur(0px);
              }
              15% {
                filter: blur(0px);
                animation-timing-function: cubic-bezier(0.705, -0.005, 0.295, 0.985);
              }
              40% {
                filter: blur(1.414214px);
              }
              100% {
                filter: blur(1.414214px);
              }
            }
            @keyframes hoverinnercircle_path_s_o {
              0% {
                stroke-opacity: 0;
              }
              25% {
                stroke-opacity: 0;
              }
              40% {
                stroke-opacity: 0.5;
              }
              100% {
                stroke-opacity: 0.5;
              }
            }
            #bloop {
              animation: bloop__ts 2000ms linear infinite normal forwards;
            }
            @keyframes bloop__ts {
              0% {
                transform: translate(105.44863px, 105.461375px) scale(1, 1);
              }
              20% {
                transform: translate(105.44863px, 105.461375px) scale(1, 1);
                animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
              }
              40% {
                transform: translate(105.44863px, 105.461375px) scale(0.9, 0.9);
                animation-timing-function: cubic-bezier(0.705, -0.005, 0.295, 0.985);
              }
              55% {
                transform: translate(105.44863px, 105.461375px) scale(1.01, 1.01);
                animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
              }
              65% {
                transform: translate(105.44863px, 105.461375px) scale(1, 1);
              }
              100% {
                transform: translate(105.44863px, 105.461375px) scale(1, 1);
              }
            }
            #bluecircle {
              animation: bluecircle_s_do 2000ms linear infinite normal forwards;
            }
            @keyframes bluecircle_s_do {
              0% {
                stroke-dashoffset: 591.97;
                animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
              }
              15% {
                stroke-dashoffset: 0;
              }
              100% {
                stroke-dashoffset: 0;
              }
            }
            #whitecircle {
              animation: whitecircle__ts 2000ms linear infinite normal forwards;
            }
            @keyframes whitecircle__ts {
              0% {
                transform: translate(105.450001px, 105.44px) scale(1, 1);
              }
              15% {
                transform: translate(105.450001px, 105.44px) scale(1, 1);
                animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
              }
              35% {
                transform: translate(105.450001px, 105.44px) scale(0, 0);
              }
              100% {
                transform: translate(105.450001px, 105.44px) scale(0, 0);
              }
            }
            #checkmark {
              animation: checkmark_s_do 2000ms linear infinite normal forwards;
            }
            @keyframes checkmark_s_do {
              0% {
                stroke-dashoffset: 141.5;
              }
              30% {
                stroke-dashoffset: 141.5;
                animation-timing-function: cubic-bezier(0.705, -0.005, 0.295, 0.985);
              }
              55% {
                stroke-dashoffset: 0;
              }
              100% {
                stroke-dashoffset: 0;
              }
            }
            #restartarrow {
              animation: restartarrow__tr 2000ms linear infinite normal forwards;
            }
            @keyframes restartarrow__tr {
              0% {
                transform: translate(93.099171px, 66.642392px) rotate(0deg);
                animation-timing-function: cubic-bezier(0.705, -0.005, 0.295, 0.985);
              }
              50% {
                transform: translate(93.099171px, 66.642392px) rotate(360deg);
              }
              100% {
                transform: translate(93.099171px, 66.642392px) rotate(360deg);
              }
            }
          </style>
          <g
            id="SpeechTestMic"
            transform="matrix(1 0 0 1 1.05136490000000 1.03861999499999)">
            <g id="GRP_listening" display="none">
              <g
                id="pulsering"
                display="block"
                transform="translate(105.450000,105.450000) scale(0.500000,0.500000)">
                <circle
                  id="pulsering_path"
                  r="94.200000"
                  transform="translate(0,0)"
                  fill="none"
                  stroke="rgb(2,59,90)"
                  stroke-width="10"
                  stroke-opacity="0"
                  stroke-miterlimit="3.600000" />
              </g>
              <g
                id="pulsecircleB"
                display="block"
                transform="translate(105.450000,105.450000) scale(0.500000,0.500000)">
                <circle
                  id="pulsecircleB_path"
                  r="94.200000"
                  transform="translate(0,0)"
                  fill="rgb(2,59,90)"
                  fill-opacity="0.3"
                  stroke="none"
                  stroke-width="1" />
              </g>
              <g
                id="pulsecircleA"
                display="block"
                transform="translate(105.450000,105.450000) scale(1,1)">
                <circle
                  id="pulsecircleA_path"
                  r="48.680000"
                  transform="translate(0,0)"
                  fill="rgb(225,235,239)"
                  stroke="none"
                  stroke-width="1" />
              </g>
              <path
                id="pulsemic_path"
                display="block"
                d="M105.450000,128.670000C111.903149,128.678053,118.093143,126.112632,122.648698,121.542061C127.204253,116.971490,129.749289,110.773088,129.720000,104.320000L129.810000,55.610000C129.988706,46.791157,125.386151,38.564647,117.777202,34.102830C110.168252,29.641013,100.741748,29.641013,93.132798,34.102830C85.523849,38.564647,80.921294,46.791157,81.100000,55.610000L81.100000,104.320000C81.094688,110.779649,83.658421,116.976253,88.226084,121.543916C92.793747,126.111579,98.990351,128.675312,105.450000,128.670000ZM148.450000,104.320000C148.450000,128.670000,127.820000,145.710000,105.450000,145.710000C83.080000,145.710000,62.450000,128.710000,62.450000,104.320000L48.600000,104.320000C48.600000,131.990000,70.680000,154.880000,97.310000,158.860000L97.310000,185.490000L113.540000,185.490000L113.540000,158.860000C140.170000,154.970000,162.250000,132.080000,162.250000,104.320000Z"
                fill="rgb(2,59,90)"
                stroke="none"
                stroke-width="1" />
            </g>
            <g id="GRP_hover" display="none">
              <g
                id="hoveroutercircle"
                display="block"
                transform="translate(105.450000,105.450000) scale(0,0)">
                <path
                  id="hoveroutercircle_path"
                  d="M-94.200000,0C-94.200000,-52.025223,-52.025223,-94.200000,0,-94.200000C52.025223,-94.200000,94.200000,-52.025223,94.200000,0C94.200000,52.025223,52.025223,94.200000,0,94.200000C-52.025223,94.200000,-94.200000,52.025223,-94.200000,0Z"
                  transform="translate(0,0)"
                  fill="none"
                  fill-opacity="0.3"
                  stroke="rgb(2,59,90)"
                  stroke-width="5"
                  stroke-opacity="0.3" />
              </g>
              <g
                id="hoverinnercircle"
                display="block"
                transform="translate(105.450000,105.450000) scale(0,0)">
                <path
                  id="hoverinnercircle_path"
                  style="filter:blur(0px)"
                  d="M-94.200000,0C-94.200000,-52.025223,-52.025223,-94.200000,0,-94.200000C52.025223,-94.200000,94.200000,-52.025223,94.200000,0C94.200000,52.025223,52.025223,94.200000,0,94.200000C-52.025223,94.200000,-94.200000,52.025223,-94.200000,0Z"
                  transform="translate(0,0)"
                  fill="none"
                  fill-opacity="0.3"
                  stroke="rgb(2,59,90)"
                  stroke-width="2"
                  stroke-opacity="0" />
              </g>
              <path
                id="hovermic"
                display="block"
                d="M105.450000,128.670000C111.903149,128.678053,118.093143,126.112632,122.648698,121.542061C127.204253,116.971490,129.749289,110.773088,129.720000,104.320000L129.810000,55.610000C129.988706,46.791157,125.386151,38.564647,117.777202,34.102830C110.168252,29.641013,100.741748,29.641013,93.132798,34.102830C85.523849,38.564647,80.921294,46.791157,81.100000,55.610000L81.100000,104.320000C81.094688,110.779649,83.658421,116.976253,88.226084,121.543916C92.793747,126.111579,98.990351,128.675312,105.450000,128.670000ZM148.450000,104.320000C148.450000,128.670000,127.820000,145.710000,105.450000,145.710000C83.080000,145.710000,62.450000,128.710000,62.450000,104.320000L48.600000,104.320000C48.600000,131.990000,70.680000,154.880000,97.310000,158.860000L97.310000,185.490000L113.540000,185.490000L113.540000,158.860000C140.170000,154.970000,162.250000,132.080000,162.250000,104.320000Z"
                fill="rgb(2,59,90)"
                stroke="none"
                stroke-width="1" />
            </g>
            <g id="GRP_mic" display="block">
              <path
                id="defaultmic_path"
                d="M105.450000,128.670000C111.903149,128.678053,118.093143,126.112632,122.648698,121.542061C127.204253,116.971490,129.749289,110.773088,129.720000,104.320000L129.810000,55.610000C129.988706,46.791157,125.386151,38.564647,117.777202,34.102830C110.168252,29.641013,100.741748,29.641013,93.132798,34.102830C85.523849,38.564647,80.921294,46.791157,81.100000,55.610000L81.100000,104.320000C81.094688,110.779649,83.658421,116.976253,88.226084,121.543916C92.793747,126.111579,98.990351,128.675312,105.450000,128.670000ZM148.450000,104.320000C148.450000,128.670000,127.820000,145.710000,105.450000,145.710000C83.080000,145.710000,62.450000,128.710000,62.450000,104.320000L48.600000,104.320000C48.600000,131.990000,70.680000,154.880000,97.310000,158.860000L97.310000,185.490000L113.540000,185.490000L113.540000,158.860000C140.170000,154.970000,162.250000,132.080000,162.250000,104.320000Z"
                fill="rgb(2,59,90)"
                stroke="none"
                stroke-width="1" />
            </g>
            <g id="GRP_miccancel" display="none">
              <path
                id="miccancel_path"
                d="M162.430000,104.070000L148.600000,104.070000C148.596638,109.815154,147.405010,115.497516,145.100000,120.760000L155.100000,130.760000C159.837864,122.658492,162.365471,113.454968,162.430000,104.070000ZM129.700000,105.450000C129.700000,104.960000,129.860000,104.560000,129.860000,104.070000L129.860000,55.240000C129.398936,42.088906,118.604174,31.665964,105.445000,31.665964C92.285826,31.665964,81.491064,42.088906,81.030000,55.240000L81.030000,56.740000ZM42.500000,38.940000L32.160000,49.280000L81.090000,98.210000L81.090000,104.070000C81.066073,110.540949,83.619891,116.755069,88.187123,121.339189C92.754354,125.923308,98.959007,128.500044,105.430000,128.500000C107.202389,128.484713,108.967206,128.266627,110.690000,127.850000L124.210000,141.370000C118.331148,144.127333,111.923266,145.574055,105.430000,145.610000C82.960000,145.610000,62.280000,128.510000,62.280000,104.080000L48.450000,104.080000C48.450000,131.870000,70.590000,154.800000,97.270000,158.790000L97.270000,185.490000L113.560000,185.490000L113.560000,158.780000C120.861413,157.698572,127.884148,155.212769,134.240000,151.460000L168.350000,185.460000L178.690000,175.120000Z"
                fill="rgb(2,59,90)"
                stroke="none"
                stroke-width="1" />
            </g>
            <g id="GRP_success" display="none">
              <g
                id="bloop"
                display="block"
                transform="translate(105.448630,105.461375) scale(1,1)">
                <g id="bluecircletop" transform="translate(-105.448630,-105.461375)">
                  <path
                    id="bluecircle"
                    display="block"
                    d="M199.660000,105.450000C199.664045,143.555298,176.713080,177.910751,141.509536,192.495820C106.305992,207.080889,65.782951,199.023150,38.837006,172.080065C11.891062,145.136981,3.829021,104.614796,18.410353,69.409704C32.991685,34.204612,67.344702,11.250000,105.450000,11.250000C157.476841,11.250000,199.654478,53.423159,199.660000,105.450000Z"
                    transform="matrix(1.00133333333333 0 0 1.00133333333333
                    -0.14059816413334 -0.14061516844001)"
                    fill="rgb(2,59,90)"
                    stroke="rgb(2,59,90)"
                    stroke-width="22.500000"
                    stroke-miterlimit="3.600000"
                    stroke-dashoffset="591.970000"
                    stroke-dasharray="591.970000" />
                  <g
                    id="whitecircle"
                    display="block"
                    transform="translate(105.450001,105.440000) scale(1,1)">
                    <path
                      id="whitecircle_path"
                      d="M204.890000,105.450000C204.884477,160.367893,160.361228,204.883681,105.443334,204.880000C50.525440,204.876318,6.008160,160.354561,6.010001,105.436667C6.011841,50.518773,50.532106,6,105.450000,6C131.824860,6,157.119329,16.478057,175.768234,35.128837C194.417139,53.779617,204.892652,79.075140,204.890000,105.450000Z"
                      transform="translate(-105.450001,-105.440000)"
                      fill="rgb(255,255,255)"
                      stroke="none"
                      stroke-width="1" />
                  </g>
                  <path
                    id="checkmark"
                    display="block"
                    d="M55.630000,110.470000L85.350000,140.610000L155.270000,70.280000"
                    fill="none"
                    stroke="rgb(255,255,255)"
                    stroke-width="13"
                    stroke-dashoffset="141.500000"
                    stroke-dasharray="141.500000" />
                </g>
              </g>
            </g>
            <g
              id="GRP_restart"
              display="none"
              transform="matrix(1 0 0 1 11.37499817000000 11.37499817000000)">
              <circle
                id="restartcircle"
                r="94.080000"
                transform="matrix(1 0 0 1 94.08000000000000 94.08000000000000)"
                fill="rgb(2,59,90)"
                stroke="rgb(2,59,90)"
                stroke-width="22.500000" />
              <g
                id="RESTARTletters"
                display="block"
                transform="matrix(1.15000000000000 0 0 1.15000000000000
                -14.60925006900001 -12.78576698300003)">
                <path
                  id="RESTARTletter_R1"
                  display="block"
                  d="M47.380000,134C47.163180,133.801080,46.925072,133.626691,46.670000,133.480000C47.379082,133.280187,48.053514,132.973320,48.670000,132.570000C49.237098,132.200109,49.737499,131.736901,50.150000,131.200000C50.548397,130.674903,50.855989,130.086759,51.060000,129.460000C51.268262,128.813878,51.372891,128.138851,51.370000,127.460000C51.390958,126.609358,51.230747,125.763988,50.900000,124.980000C50.588778,124.204370,50.082410,123.522323,49.430000,123C48.678149,122.411131,47.813753,121.982336,46.890000,121.740000C45.677778,121.412615,44.425456,121.257758,43.170000,121.280000L36.660000,121.280000L36.660000,142.600000L40.660000,142.600000L40.660000,134.240000L42.370000,134.240000C42.678329,134.223141,42.986374,134.277904,43.270000,134.400000C43.494834,134.533167,43.680980,134.722760,43.810000,134.950000L48.300000,141.770000C48.588746,142.307186,49.160878,142.630226,49.770000,142.600000L53.350000,142.600000L48,134.690000C47.820792,134.436733,47.612727,134.205177,47.380000,134ZM45.060000,131.140000C44.413803,131.345931,43.738074,131.443912,43.060000,131.430000L40.620000,131.430000L40.620000,124.350000L43.170000,124.350000C44.315340,124.259309,45.458399,124.551229,46.420000,125.180000C47.168399,125.796665,47.580202,126.731570,47.530000,127.700000C47.541146,128.209772,47.449314,128.716553,47.260000,129.190000C47.082019,129.641381,46.797211,130.042858,46.430000,130.360000C46.034288,130.708055,45.566426,130.964184,45.060000,131.110000Z"
                  fill="rgb(255,255,255)"
                  stroke="none"
                  stroke-width="1" />
                <polygon
                  id="RESTARTletter_E"
                  display="block"
                  points="55.620000,142.570000 69.070000,142.570000 69.070000,139.400000
                  59.600000,139.400000 59.600000,133.370000 67.060000,133.370000
                  67.060000,130.320000 59.600000,130.320000 59.600000,124.410000
                  69.070000,124.410000 69.070000,121.250000 55.620000,121.250000
                  55.620000,142.570000"
                  fill="rgb(255,255,255)"
                  stroke="none"
                  stroke-width="1" />
                <path
                  id="RESTARTletter_S"
                  display="block"
                  d="M83.740000,132C83.266458,131.589323,82.733832,131.252218,82.160000,131C81.571592,130.718297,80.967229,130.471209,80.350000,130.260000L78.540000,129.660000C78.007835,129.486834,77.492406,129.265936,77,129C76.576550,128.798290,76.196204,128.516427,75.880000,128.170000C75.596447,127.816744,75.450758,127.372572,75.470000,126.920000C75.459415,126.552143,75.531164,126.186569,75.680000,125.850000C75.810179,125.523680,76.024020,125.237409,76.300000,125.020000C76.595069,124.774368,76.934544,124.587656,77.300000,124.470000C77.766825,124.329524,78.252561,124.262061,78.740000,124.270000C79.287437,124.265933,79.831671,124.353822,80.350000,124.530000C80.754873,124.659456,81.146613,124.826866,81.520000,125.030000C81.860000,125.220000,82.140000,125.390000,82.390000,125.550000C82.586584,125.680593,82.814377,125.756524,83.050000,125.770000C83.227680,125.781002,83.403868,125.731669,83.550000,125.630000C83.709913,125.514244,83.837335,125.359271,83.920000,125.180000L84.920000,123.280000C84.130210,122.557083,83.206025,121.996457,82.200000,121.630000C81.083836,121.229781,79.905706,121.030040,78.720000,121.040000C77.697739,121.020464,76.680668,121.189976,75.720000,121.540000C74.909266,121.851393,74.168314,122.320436,73.540000,122.920000C72.385219,124.024277,71.731424,125.552206,71.730000,127.150000C71.698224,127.996736,71.841195,128.840943,72.150000,129.630000C72.399535,130.255030,72.777718,130.820601,73.260000,131.290000C73.723668,131.739103,74.261619,132.104503,74.850000,132.370000C75.432107,132.641843,76.029823,132.878926,76.640000,133.080000L78.440000,133.620000C78.984860,133.772645,79.513922,133.976903,80.020000,134.230000C80.450596,134.446408,80.829262,134.753434,81.130000,135.130000C81.423182,135.496513,81.585132,135.950677,81.590000,136.420000C81.640325,137.290213,81.299247,138.137407,80.660000,138.730000C79.917186,139.317065,78.985350,139.612265,78.040000,139.560000C77.396926,139.576862,76.756244,139.475166,76.150000,139.260000C75.667268,139.079373,75.202009,138.855112,74.760000,138.590000C74.370000,138.340000,74.030000,138.110000,73.760000,137.910000C73.519703,137.730347,73.229892,137.629088,72.930000,137.620000C72.757147,137.603854,72.583346,137.638615,72.430000,137.720000C72.285092,137.811127,72.156618,137.926078,72.050000,138.060000L70.890000,140C71.321703,140.432061,71.797655,140.817514,72.310000,141.150000C72.846743,141.483369,73.412350,141.767846,74,142C74.613725,142.250104,75.249952,142.440972,75.900000,142.570000C76.557854,142.706321,77.228179,142.773353,77.900000,142.770000C78.974772,142.791766,80.043845,142.608497,81.050000,142.230000C81.912817,141.898008,82.701325,141.398393,83.370000,140.760000C83.998927,140.135730,84.489543,139.386177,84.810000,138.560000C85.140086,137.698067,85.309548,136.782976,85.310000,135.860000C85.329109,135.084652,85.182510,134.314155,84.880000,133.600000C84.616428,132.992612,84.228016,132.447472,83.740000,132Z"
                  fill="rgb(255,255,255)"
                  stroke="none"
                  stroke-width="1" />
                <polygon
                  id="RESTARTletter_T1"
                  display="block"
                  points="103.610000,121.250000 86.790000,121.250000
                  86.790000,124.520000 93.220000,124.520000 93.220000,142.570000
                  97.190000,142.570000 97.190000,124.520000 103.610000,124.520000
                  103.610000,121.250000"
                  fill="rgb(255,255,255)"
                  stroke="none"
                  stroke-width="1" />
                <path
                  id="RESTARTletter_A"
                  display="block"
                  d="M110.240000,121.250000L101.840000,142.570000L104.930000,142.570000C105.229396,142.577523,105.522331,142.482231,105.760000,142.300000C105.968755,142.136688,106.128014,141.918572,106.220000,141.670000L107.810000,137.320000L116.650000,137.320000L118.240000,141.670000C118.350335,141.919133,118.518280,142.138490,118.730000,142.310000C118.968608,142.489394,119.261687,142.581202,119.560000,142.570000L122.630000,142.570000L114.280000,121.250000ZM108.840000,134.520000L111.420000,127.460000C111.550000,127.140000,111.680000,126.750000,111.820000,126.310000C111.960000,125.870000,112.090000,125.410000,112.220000,124.910000C112.360000,125.410000,112.500000,125.910000,112.630000,126.310000C112.760000,126.710000,112.900000,127.120000,113.030000,127.430000L115.620000,134.520000Z"
                  fill="rgb(255,255,255)"
                  stroke="none"
                  stroke-width="1" />
                <path
                  id="RESTARTletter_R2"
                  display="block"
                  d="M135.560000,134C135.343180,133.801080,135.105072,133.626691,134.850000,133.480000C135.559170,133.271090,136.233242,132.957647,136.850000,132.550000C137.972579,131.810355,138.814239,130.715141,139.240000,129.440000C139.443557,128.792771,139.548072,128.118482,139.550000,127.440000C139.560597,126.590235,139.400784,125.746963,139.080000,124.960000C138.762873,124.198891,138.256941,123.531198,137.610000,123.020000C136.856261,122.428207,135.987976,121.999172,135.060000,121.760000C133.847778,121.432615,132.595456,121.277758,131.340000,121.300000L124.840000,121.300000L124.840000,142.620000L128.840000,142.620000L128.840000,134.260000L130.540000,134.260000C130.848329,134.243141,131.156374,134.297904,131.440000,134.420000C131.664834,134.553167,131.850980,134.742760,131.980000,134.970000L136.470000,141.790000C136.758746,142.327186,137.330878,142.650226,137.940000,142.620000L141.520000,142.620000L136.180000,134.760000C136.008368,134.479997,135.799829,134.224369,135.560000,134ZM133.240000,131.120000C132.593479,131.324522,131.917984,131.422469,131.240000,131.410000L128.790000,131.410000L128.790000,124.340000L131.320000,124.340000C132.477541,124.246152,133.632136,124.553338,134.590000,125.210000C135.319677,125.820277,135.716685,126.740446,135.660000,127.690000C135.671146,128.199772,135.579314,128.706553,135.390000,129.180000C135.212019,129.631381,134.927211,130.032858,134.560000,130.350000C134.181519,130.697698,133.730722,130.957248,133.240000,131.110000Z"
                  fill="rgb(255,255,255)"
                  stroke="none"
                  stroke-width="1" />
                <polygon
                  id="RESTARTletter_T2"
                  display="block"
                  points="158.110000,121.250000 141.290000,121.250000
                  141.290000,124.520000 147.720000,124.520000 147.720000,142.570000
                  151.690000,142.570000 151.690000,124.520000 158.130000,124.520000
                  158.110000,121.250000"
                  fill="rgb(255,255,255)"
                  stroke="none"
                  stroke-width="1" />
              </g>
              <g
                id="restartarrow"
                display="block"
                transform="translate(93.099171,66.642392) rotate(0)">
                <path
                  id="restartarrow_path"
                  display="block"
                  d="M118.240000,76.880000C115.009686,87.691855,105.074089,95.107996,93.790000,95.130000L93.370000,95.130000C82.051662,94.949928,72.207986,87.327119,69.201177,76.413993C66.194369,65.500868,70.744844,53.912151,80.373794,47.960636C90.002744,42.009122,102.403124,43.120759,110.820000,50.690000L102.310000,59.210000L128.630000,59.880000L128,33.560000L119.380000,42.190000C107.134269,30.803665,88.828304,28.903762,74.505275,37.532632C60.182246,46.161502,53.305386,63.232728,57.647535,79.380554C61.989684,95.528381,76.500932,106.848347,93.220000,107.130000L93.840000,107.130000C110.449201,107.111269,125.080646,96.202714,129.840000,80.290000Z"
                  transform="scale(1.100000,1.100000) translate(-93.099171,-69.642392)"
                  fill="rgb(255,255,255)"
                  stroke="none"
                  stroke-width="1" />
              </g>
            </g>
            <g
      id="GRP_restarthover"
      display="none"
      transform="matrix(1 0 0 1 11.37499817000000 11.37499817000000)">
      <circle
        id="restarthovercircle"
        display="block"
        r="94.080000"
        transform="matrix(1.10000000000000 0 0 1.10000000000000
        94.08000000000000 94.08000000049999)"
        fill="none"
        stroke="rgb(112,146,166)"
        stroke-width="3" />
      <g
        id="RESTARThoverletters"
        display="block"
        transform="matrix(1.15000000000000 0 0 1.15000000000000
        -14.60925006900001 -12.78576698300003)">
        <path
          id="RH_R1"
          display="block"
          d="M47.380000,134C47.163180,133.801080,46.925072,133.626691,46.670000,133.480000C47.379082,133.280187,48.053514,132.973320,48.670000,132.570000C49.237098,132.200109,49.737499,131.736901,50.150000,131.200000C50.548397,130.674903,50.855989,130.086759,51.060000,129.460000C51.268262,128.813878,51.372891,128.138851,51.370000,127.460000C51.390958,126.609358,51.230747,125.763988,50.900000,124.980000C50.588778,124.204370,50.082410,123.522323,49.430000,123C48.678149,122.411131,47.813753,121.982336,46.890000,121.740000C45.677778,121.412615,44.425456,121.257758,43.170000,121.280000L36.660000,121.280000L36.660000,142.600000L40.660000,142.600000L40.660000,134.240000L42.370000,134.240000C42.678329,134.223141,42.986374,134.277904,43.270000,134.400000C43.494834,134.533167,43.680980,134.722760,43.810000,134.950000L48.300000,141.770000C48.588746,142.307186,49.160878,142.630226,49.770000,142.600000L53.350000,142.600000L48,134.690000C47.820792,134.436733,47.612727,134.205177,47.380000,134ZM45.060000,131.140000C44.413803,131.345931,43.738074,131.443912,43.060000,131.430000L40.620000,131.430000L40.620000,124.350000L43.170000,124.350000C44.315340,124.259309,45.458399,124.551229,46.420000,125.180000C47.168399,125.796665,47.580202,126.731570,47.530000,127.700000C47.541146,128.209772,47.449314,128.716553,47.260000,129.190000C47.082019,129.641381,46.797211,130.042858,46.430000,130.360000C46.034288,130.708055,45.566426,130.964184,45.060000,131.110000Z"
          fill="rgb(112,146,166)"
          stroke="none"
          stroke-width="1" />
        <polygon
          id="RH_E"
          points="55.620000,142.570000 69.070000,142.570000 69.070000,139.400000
          59.600000,139.400000 59.600000,133.370000 67.060000,133.370000
          67.060000,130.320000 59.600000,130.320000 59.600000,124.410000
          69.070000,124.410000 69.070000,121.250000 55.620000,121.250000
          55.620000,142.570000"
          fill="rgb(112,146,166)"
          stroke="none"
          stroke-width="1" />
        <path
          id="RH_S"
          d="M83.740000,132C83.266458,131.589323,82.733832,131.252218,82.160000,131C81.571592,130.718297,80.967229,130.471209,80.350000,130.260000L78.540000,129.660000C78.007835,129.486834,77.492406,129.265936,77,129C76.576550,128.798290,76.196204,128.516427,75.880000,128.170000C75.596447,127.816744,75.450758,127.372572,75.470000,126.920000C75.459415,126.552143,75.531164,126.186569,75.680000,125.850000C75.810179,125.523680,76.024020,125.237409,76.300000,125.020000C76.595069,124.774368,76.934544,124.587656,77.300000,124.470000C77.766825,124.329524,78.252561,124.262061,78.740000,124.270000C79.287437,124.265933,79.831671,124.353822,80.350000,124.530000C80.754873,124.659456,81.146613,124.826866,81.520000,125.030000C81.860000,125.220000,82.140000,125.390000,82.390000,125.550000C82.586584,125.680593,82.814377,125.756524,83.050000,125.770000C83.227680,125.781002,83.403868,125.731669,83.550000,125.630000C83.709913,125.514244,83.837335,125.359271,83.920000,125.180000L84.920000,123.280000C84.130210,122.557083,83.206025,121.996457,82.200000,121.630000C81.083836,121.229781,79.905706,121.030040,78.720000,121.040000C77.697739,121.020464,76.680668,121.189976,75.720000,121.540000C74.909266,121.851393,74.168314,122.320436,73.540000,122.920000C72.385219,124.024277,71.731424,125.552206,71.730000,127.150000C71.698224,127.996736,71.841195,128.840943,72.150000,129.630000C72.399535,130.255030,72.777718,130.820601,73.260000,131.290000C73.723668,131.739103,74.261619,132.104503,74.850000,132.370000C75.432107,132.641843,76.029823,132.878926,76.640000,133.080000L78.440000,133.620000C78.984860,133.772645,79.513922,133.976903,80.020000,134.230000C80.450596,134.446408,80.829262,134.753434,81.130000,135.130000C81.423182,135.496513,81.585132,135.950677,81.590000,136.420000C81.640325,137.290213,81.299247,138.137407,80.660000,138.730000C79.917186,139.317065,78.985350,139.612265,78.040000,139.560000C77.396926,139.576862,76.756244,139.475166,76.150000,139.260000C75.667268,139.079373,75.202009,138.855112,74.760000,138.590000C74.370000,138.340000,74.030000,138.110000,73.760000,137.910000C73.519703,137.730347,73.229892,137.629088,72.930000,137.620000C72.757147,137.603854,72.583346,137.638615,72.430000,137.720000C72.285092,137.811127,72.156618,137.926078,72.050000,138.060000L70.890000,140C71.321703,140.432061,71.797655,140.817514,72.310000,141.150000C72.846743,141.483369,73.412350,141.767846,74,142C74.613725,142.250104,75.249952,142.440972,75.900000,142.570000C76.557854,142.706321,77.228179,142.773353,77.900000,142.770000C78.974772,142.791766,80.043845,142.608497,81.050000,142.230000C81.912817,141.898008,82.701325,141.398393,83.370000,140.760000C83.998927,140.135730,84.489543,139.386177,84.810000,138.560000C85.140086,137.698067,85.309548,136.782976,85.310000,135.860000C85.329109,135.084652,85.182510,134.314155,84.880000,133.600000C84.616428,132.992612,84.228016,132.447472,83.740000,132Z"
          fill="rgb(112,146,166)"
          stroke="none"
          stroke-width="1" />
        <polygon
          id="RH_T1"
          points="103.610000,121.250000 86.790000,121.250000
          86.790000,124.520000 93.220000,124.520000 93.220000,142.570000
          97.190000,142.570000 97.190000,124.520000 103.610000,124.520000
          103.610000,121.250000"
          fill="rgb(112,146,166)"
          stroke="none"
          stroke-width="1" />
        <path
          id="RH_A"
          d="M110.240000,121.250000L101.840000,142.570000L104.930000,142.570000C105.229396,142.577523,105.522331,142.482231,105.760000,142.300000C105.968755,142.136688,106.128014,141.918572,106.220000,141.670000L107.810000,137.320000L116.650000,137.320000L118.240000,141.670000C118.350335,141.919133,118.518280,142.138490,118.730000,142.310000C118.968608,142.489394,119.261687,142.581202,119.560000,142.570000L122.630000,142.570000L114.280000,121.250000ZM108.840000,134.520000L111.420000,127.460000C111.550000,127.140000,111.680000,126.750000,111.820000,126.310000C111.960000,125.870000,112.090000,125.410000,112.220000,124.910000C112.360000,125.410000,112.500000,125.910000,112.630000,126.310000C112.760000,126.710000,112.900000,127.120000,113.030000,127.430000L115.620000,134.520000Z"
          fill="rgb(112,146,166)"
          stroke="none"
          stroke-width="1" />
        <path
          id="RH_R2"
          d="M135.560000,134C135.343180,133.801080,135.105072,133.626691,134.850000,133.480000C135.559170,133.271090,136.233242,132.957647,136.850000,132.550000C137.972579,131.810355,138.814239,130.715141,139.240000,129.440000C139.443557,128.792771,139.548072,128.118482,139.550000,127.440000C139.560597,126.590235,139.400784,125.746963,139.080000,124.960000C138.762873,124.198891,138.256941,123.531198,137.610000,123.020000C136.856261,122.428207,135.987976,121.999172,135.060000,121.760000C133.847778,121.432615,132.595456,121.277758,131.340000,121.300000L124.840000,121.300000L124.840000,142.620000L128.840000,142.620000L128.840000,134.260000L130.540000,134.260000C130.848329,134.243141,131.156374,134.297904,131.440000,134.420000C131.664834,134.553167,131.850980,134.742760,131.980000,134.970000L136.470000,141.790000C136.758746,142.327186,137.330878,142.650226,137.940000,142.620000L141.520000,142.620000L136.180000,134.760000C136.008368,134.479997,135.799829,134.224369,135.560000,134ZM133.240000,131.120000C132.593479,131.324522,131.917984,131.422469,131.240000,131.410000L128.790000,131.410000L128.790000,124.340000L131.320000,124.340000C132.477541,124.246152,133.632136,124.553338,134.590000,125.210000C135.319677,125.820277,135.716685,126.740446,135.660000,127.690000C135.671146,128.199772,135.579314,128.706553,135.390000,129.180000C135.212019,129.631381,134.927211,130.032858,134.560000,130.350000C134.181519,130.697698,133.730722,130.957248,133.240000,131.110000Z"
          fill="rgb(112,146,166)"
          stroke="none"
          stroke-width="1" />
        <polygon
          id="RH_T2"
          points="158.110000,121.250000 141.290000,121.250000
          141.290000,124.520000 147.720000,124.520000 147.720000,142.570000
          151.690000,142.570000 151.690000,124.520000 158.130000,124.520000
          158.110000,121.250000"
          fill="rgb(112,146,166)"
          stroke="none"
          stroke-width="1" />
      </g>
      <path
        id="restarthoverarrow"
        display="block"
        d="M118.240000,76.880000C115.009686,87.691855,105.074089,95.107996,93.790000,95.130000L93.370000,95.130000C82.051662,94.949928,72.207986,87.327119,69.201177,76.413993C66.194369,65.500868,70.744844,53.912151,80.373794,47.960636C90.002744,42.009122,102.403124,43.120759,110.820000,50.690000L102.310000,59.210000L128.630000,59.880000L128,33.560000L119.380000,42.190000C107.134269,30.803665,88.828304,28.903762,74.505275,37.532632C60.182246,46.161502,53.305386,63.232728,57.647535,79.380554C61.989684,95.528381,76.500932,106.848347,93.220000,107.130000L93.840000,107.130000C110.449201,107.111269,125.080646,96.202714,129.840000,80.290000Z"
        transform="matrix(1.10000000000000 0 0 1.10000000000000
        -9.30991709400001 -9.96423921450001)"
        fill="rgb(112,146,166)"
        stroke="none"
        stroke-width="1" />
    </g>
      </g>
    </svg>
    </div>                
  </div>
</InputFeedComponent>
<p id="speechRecognitionHelp">{!listening?clickToStartText:""}&nbsp;</p>